import OnboardingFlow from './Onboarding-Flow';

export default {
  OnboardingFlow
};
